import { useState, useEffect } from "react";
import { nav_links } from "./NavItem";
import { ChevronDown } from "lucide-react";
import Icon, { icons } from "./icon/Icon";
import { Link, useLocation } from "react-router-dom";
import SubMenu from "./sub-menu";

interface NavigationProps {
  isOpen: boolean;
}

function Navigation(props: NavigationProps) {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const activeParent = nav_links.find((link) =>
      link.children?.some((category) =>
        category.links.some((sublink) => location.pathname === sublink.href)
      )
    );
    setOpenDropdown(activeParent?.text || null);
  }, [location.pathname]);

  const handleToggle = (name: string) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    <nav className="flex-grow mt-4">
      {nav_links.map((link, index) => {
        const isMainLinkActive = location.pathname === link.href;
        const isSubLinkActive = link.children?.some((category) =>
          category.links.some((sublink) => location.pathname === sublink.href)
        );
        const isDropdownOpen = openDropdown === link.text || isSubLinkActive;

        return link.children ? (
          <div key={index} className="relative">
            <Link
              to={link.href || "#"}
              className={`flex group items-center ${
                props.isOpen ? "justify-between" : "justify-center"
              } w-full h-[36px] px-[10px] leading-[20px] font-[300] text-[16px] transition-all duration-300 ${
                isMainLinkActive || isSubLinkActive
                  ? "bg-[#0193F8] text-[#05050F] !font-[400]"
                  : "text-[#DDEBFF] hover:bg-[#0193F8] hover:text-[#05050F]"
              } ${
                props.isOpen
                  ? "my-[0.8rem] rounded-[13px]"
                  : "justify-center !h-[50px] my-[0.5rem] rounded-[10px]"
              }`}
            >
              <div className="flex items-center">
                <Icon
                  isOpen={props.isOpen}
                  isActive={!!(isMainLinkActive || isSubLinkActive)}
                  name={link.icon as keyof typeof icons}
                />
                {props.isOpen && <span>{link.text}</span>}
              </div>

              {props.isOpen && (
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleToggle(link.text);
                  }}
                  className="cursor-pointer p-1 rounded-md hover:bg-white/10 transition"
                >
                  <ChevronDown size={18} />
                </div>
              )}
            </Link>

            <SubMenu
              isOpen={props.isOpen}
              link={link}
              isDropdownOpen={!!isDropdownOpen}
              setOpenDropdown={setOpenDropdown}
            />
          </div>
        ) : (
          <Link
            to={link.href || "/"}
            key={index}
            className={`flex items-center text-[#DDEBFF] group h-[36px] px-[10px] text-[16px] leading-[20px] font-[300] transition-all duration-300 ${
              isMainLinkActive
                ? "bg-[#0193F8] !text-[#05050F] !font-[400]"
                : "hover:bg-[#0193F8] hover:text-[#05050F]"
            } ${
              props.isOpen
                ? "my-[0.9rem] rounded-[12px]"
                : "justify-center !h-[50px] my-[0.5rem] rounded-[10px]"
            }`}
          >
            <Icon
              isOpen={props.isOpen}
              isActive={isMainLinkActive}
              name={link.icon as keyof typeof icons}
            />
            {props.isOpen && <span className="ml-0">{link.text}</span>}
          </Link>
        );
      })}
    </nav>
  );
}

export default Navigation;
